// Default rest between sets (spec section 8 nice-to-have): ~2.5 min for compounds,
// shorter for isolation. Derived from structure + muscle group so no extra field
// is needed on the catalog.

import type { Exercise, MuscleGroup } from '../../domain/types';

const COMPOUND_MUSCLES = new Set<MuscleGroup>(['chest', 'back', 'quad', 'hamstring', 'front_delt', 'glute']);

export function restSeconds(ex: Pick<Exercise, 'structure' | 'muscleGroup'>): number {
  if (ex.structure === 'ramp_top_backoff' || ex.structure === 'amrap') return 180;
  if (COMPOUND_MUSCLES.has(ex.muscleGroup)) return 150;
  return 90;
}
